







































import { Component, Mixins, PropSync } from 'vue-property-decorator';
import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { compass } from '@resclick/compass';

@Component
export default class TabEmail extends Mixins(ModalTabMixin) {
  @PropSync('id', { type: String }) idSync!: string;

  logoFile = null;
  loading = false;
  logoSrc = '';

  created() {
    this.form = this.$crsForm('companies', 'update', {});

    this.$on('update-data', () => {
      this.getForm()
        .then((res: any) => res.data)
        .then((data: any) => {
          this.form = this.$crsForm('companies', 'update', data);
        });
    });
  }

  get cdnUrl() {
    return process.env.VUE_APP_CDN_URL;
  }

  uploadImage() {
    this.loading = true;

    const file = this.logoFile as any;

    const formData: any = new FormData();
    formData.append('file', file);

    compass
      .do('companies', 'uploadLogo', {
        params: { companyId: this.idSync },
        data: formData,
      })
      .then((res) => (this.logoSrc = res.data.logo as string))
      .finally(() => (this.loading = false));
  }

  async getForm() {
    return compass
      .do('companies', 'findOne', {
        params: { companyId: this.idSync },
        select: ['logo'],
      })
      .then((res) => (this.logoSrc = res.data.logo as string));
  }
}
